import { render, staticRenderFns } from "./CertificationEdit.vue?vue&type=template&id=44971840&scoped=true"
import script from "./CertificationEdit.vue?vue&type=script&lang=js"
export * from "./CertificationEdit.vue?vue&type=script&lang=js"
import style0 from "./CertificationEdit.vue?vue&type=style&index=0&id=44971840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44971840",
  null
  
)

export default component.exports